import React from "react";
import { ADDED, AVAILABLE } from "../../configurations/Constants";

function PanelRegisteredField({
  currentRecord,
  indexValue,
  sortedUsersField,
  coords,
  btnSubmitClick,
  showFieldOnMAP,
  handleRegisterEditClick,
  handleRegisteredDeleteClick,
}) {
  const fieldId = sortedUsersField.field_id;
  const guid = sortedUsersField.guid;
  const fieldIrrigUnitid = sortedUsersField.irrig_unit_id;
  const registeredFieldName = sortedUsersField.field_name;
  const fieldProperties = sortedUsersField;

  return (
    <div className="p-relative">
      <div className="text-end">
        {btnSubmitClick ? (
          <>
            <span>
              <i className="fa-regular fa-pen-to-square" />
            </span>
            <span>
              <i className="fa-regular fa-trash-can" />
            </span>
          </>
        ) : (
          <>
            <span
              className="cursor-pointer right-30"
              onClick={(e) => {
                handleRegisterEditClick(
                  e,
                  fieldIrrigUnitid,
                  guid,
                  fieldId,
                  fieldProperties
                );
              }}
            >
              <i className="fa-regular fa-pen-to-square" />
            </span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                handleRegisteredDeleteClick(
                  fieldId,
                  currentRecord,
                  guid,
                  fieldIrrigUnitid,
                  registeredFieldName
                );
              }}
            >
              <i className="fa-regular fa-trash-can" />
            </span>
          </>
        )}
      </div>
      <ul key={indexValue}>
        <li>
          <a
            className="highlight-field cursor-pointer"
            onClick={(e) => {
              showFieldOnMAP(
                e,
                coords,
                1000,
                ADDED,
                AVAILABLE,
                fieldIrrigUnitid
              );
            }}
          >
            {sortedUsersField.field_name}
          </a>
        </li>
      </ul>
    </div>
  );
}

export default PanelRegisteredField;
